export default __webpack_public_path__ + "99e275ee1e8ad67f7f017adad2c51789.png";